export var isStreamingPayload = function isStreamingPayload(request) {
  return (request === null || request === void 0 ? void 0 : request.body) instanceof ReadableStream;
};